import React from 'react';
import {ErrorBoundary as ReactErrorBoundary} from 'react-error-boundary';

import {Anchor, Heading, Icon, Text} from '@albert-io/atomic';
import {notifyBoundaryError} from '@albert-io/notifier';

const WrittenSubmissionErrorFallback = ({
  resetErrorBoundary
}: {
  resetErrorBoundary?: () => void;
}) => (
  <div className='mb-x4 p-x4 flex w-full flex-col items-center'>
    <Icon icon={['far', 'frown-open']} />
    <Heading as='h2' size='m'>
      Something went wrong
    </Heading>
    <Text color='negative'>There was a problem loading the answer area.</Text>
    <Anchor
      as='button'
      className='mt-x2'
      data-testid='written-submission-error__retry-btn'
      onClick={() => resetErrorBoundary?.()}
    >
      <Icon className='mr-x2' icon='redo' />
      <Text color='brand'>Retry</Text>
    </Anchor>
  </div>
);

/**
 * Crash boundary for the written-response editor tree. Retry resets the boundary,
 * which remounts the editor; the draft survives in the registered question store.
 */
export default function ErrorBoundary({children}: React.PropsWithChildren) {
  return (
    <ReactErrorBoundary
      FallbackComponent={WrittenSubmissionErrorFallback}
      onError={notifyBoundaryError(
        'WrittenSubmission editor tree threw at render',
        'free-response'
      )}
    >
      {children}
    </ReactErrorBoundary>
  );
}
